import {Middleware} from 'redux';
import {
    addProductToCart,
    addProduct,
    fetchProducts,
    removeProduct,
    setLoading,
    setProductQuantity,
    updateProductQuantity
} from '../cart/cartSlice';
import {RootState} from '../shopStore';
import {fetchProduct} from '../product/productSlice';

interface DebounceTimers {
    [productId: number]: number;
}

const debounceTimers: DebounceTimers = {};
let fetchProductsTimer: null | number = null;

const cartMiddleware: Middleware<{}, RootState> = ({dispatch}) => next => (action: any) => {
    if (![
        setProductQuantity.type.toString(),
        removeProduct.type.toString(),
        addProduct.type.toString(),
        fetchProduct.typePrefix.toString()
    ].includes(action.type)) {
        return next(action);
    }

    if (action.payload) {
        const {id, quantity} = action.payload;

        if (debounceTimers[id]) {
            clearTimeout(debounceTimers[id]);
        }

        if (fetchProductsTimer) {
            clearTimeout(fetchProductsTimer);
        }

        dispatch(setLoading(true))

        debounceTimers[id] = window.setTimeout(() => {
            if ([addProduct.type.toString()].includes(action.type)) {
                dispatch(addProductToCart({id, quantity}) as any)
                    .then(() => {
                        fetchProductsDebounced(() => dispatch(fetchProducts() as any))
                    })
            }
            if ([setProductQuantity.type.toString(), removeProduct.type.toString()].includes(action.type)) {
                dispatch(updateProductQuantity({id, quantity}) as any)
                    .then(() => {
                        //dispatch(setLoading(false))
                        fetchProductsDebounced(() => dispatch(fetchProducts() as any));
                    });
            }
            delete debounceTimers[id];
        }, 700);
    }

    return next(action);
};

function fetchProductsDebounced(cb: () => void) {
    if (fetchProductsTimer) {
        clearTimeout(fetchProductsTimer);
    }

    fetchProductsTimer = window.setTimeout(() => {
        fetchProductsTimer = null;
        cb();
    }, 1000);
}

export default cartMiddleware;